import type { ReactNode } from 'react';

import { General, Time } from '../StrokeIcons';
import type { ColorName, Style } from './buttonClasses';
import FilterSelect from './FilterSelect';
import type { Size, UpdateStatus } from './types';

export type ReminderOption = {
  value: string;
  label: string;
};

export type ReminderFilterSelectProps = {
  reminderOptions: ReminderOption[];
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  includeRemoveOption?: boolean;
  size?: Size;
  disabled?: boolean;
  /** Show the selected label/placeholder text. Default true. */
  showText?: boolean;
  /** Show the dropdown chevron. Default true. */
  showChevron?: boolean;
  bordered?: boolean;
  shape?: 'rounded' | 'pill' | 'square';
  color?: ColorName;
  tone?: Style;
  tooltip?: ReactNode;
  /** Status for async operations: 'updating' shows spinner, 'success' shows checkmark, 'error' shows warning. */
  status?: UpdateStatus;
  /** Called when user wants to create a new reminder from the filter query. */
  onCreate?: (value: string) => void;
};

export default function ReminderFilterSelect({
  reminderOptions,
  value,
  onChange,
  placeholder = 'Select reminder',
  className,
  includeRemoveOption,
  size,
  disabled,
  showText,
  showChevron,
  bordered,
  shape,
  color,
  tone,
  tooltip,
  status,
  onCreate,
}: ReminderFilterSelectProps) {
  let options = reminderOptions.map((reminder) => ({
    value: reminder.value,
    label: reminder.label,
    icon: <Time.StepReminder />,
  }));

  if (includeRemoveOption) {
    options = [{ value: '', label: 'Remove reminder', icon: <General.Trash01 /> }, ...options];
  }

  return (
    <FilterSelect
      icon={<Time.StepReminder />}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
      status={status}
      disabled={disabled}
      autoWidth
      size={size}
      showText={showText}
      showChevron={showChevron}
      bordered={bordered}
      shape={shape}
      color={color}
      tone={tone}
      tooltip={tooltip}
      onCreate={onCreate}
    />
  );
}
